module.exports = __webpack_public_path__ + "static/media/img_1.ff948412.png";